import React from "react";

export const View = (props) => {
  return (
    <div
      className={`modal-section-title ${
        props.noBottomBorder ? "no-bottom-border" : null
      } ${
        props.noTopMargin ? "no-top-margin" : null
      } flex-container row justify-content--between align-items--end`}
    >
      <div className="main-header">{props.key_id}</div>
      <div className="secondary-section">{props.value}</div>
    </div>
  );
};
